import '../actions/dragDrop/dceee0fadda495c05a6c129bf8b6bb46008c208e2061c8d61ca150574931f524.cfe-internal.js';
import { REMOVE_SOURCE, REMOVE_TARGET, ADD_TARGET, ADD_SOURCE } from '../actions/924e2c35d164e222a46ac0f398ff0d07c648c8824560ac57471f964ea7c90e91.cfe-internal.js';
import { areArraysEqual } from '../utils/d4b95dcf8155cc44ad87641e8e8d7207af0bbb42d46d001ff054d891afeea5ae.cfe-internal.js';
import { NONE, ALL } from '../utils/a2bcc94c0cad1c58e9fcd7175f4742ca80e66a9d2e603f19477976381d3008b7.cfe-internal.js';
import { xor } from '../utils/aceb1437b878bf73e9db047b007173ff6e845c291157fcc88aeb319cc459f22a.cfe-internal.js';
import { DROP, END_DRAG, PUBLISH_DRAG_SOURCE, BEGIN_DRAG, HOVER } from '../actions/dragDrop/be0378ab1f16348a8496fedc6004874b221f7fe70c6044381814973cb89e98e5.cfe-internal.js';

function reduce() {
  var _state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case HOVER:
      break;
    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;
    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }
  var _action$payload = action.payload,
    _action$payload$targe = _action$payload.targetIds,
    targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe,
    _action$payload$prevT = _action$payload.prevTargetIds,
    prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
  var result = xor(targetIds, prevTargetIds);
  var didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);
  if (!didChange) {
    return NONE;
  }
  // Check the target ids at the innermost position. If they are valid, add them
  // to the result
  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
  var innermostTargetId = targetIds[targetIds.length - 1];
  if (prevInnermostTargetId !== innermostTargetId) {
    if (prevInnermostTargetId) {
      result.push(prevInnermostTargetId);
    }
    if (innermostTargetId) {
      result.push(innermostTargetId);
    }
  }
  return result;
}

export { reduce };
